export function nonFalsey<TValue>(
  value: TValue | null | undefined | false,
): value is TValue {
  return Boolean(value);
}
